export enum UserTeams {
  E_COMMERCE = 'e-Commerce',
  RETAIL = 'Retail',
  DIGITAL = 'Digital',
  CORPORATE = 'Corporate',
  INSURANCE = 'Insurance'
}
